import { render, staticRenderFns } from "./Preliminary.vue?vue&type=template&id=255eb1c4&scoped=true&"
import script from "./Preliminary.vue?vue&type=script&lang=js&"
export * from "./Preliminary.vue?vue&type=script&lang=js&"
import style0 from "./Preliminary.vue?vue&type=style&index=0&id=255eb1c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255eb1c4",
  null
  
)

export default component.exports